import React from 'react';
import '../css/menu.css';
import { useNavigate } from "react-router-dom";


const MenuButton = ({image, redirect, name, active}) => {

    const navigate = useNavigate();
    const redirectToPage = () => {
        navigate(redirect);
    }
    
    return (
        <div className='btn-section'>
            <button onClick={redirectToPage}
                className={active ? 'menu-btn menu-btn-active' : 'menu-btn'}
            >
                <div className='btn-icon'>
                    <img src={image} alt="" className='img-icon' />
                </div>
                <div className='btn-legend'>
                    {name}
                </div>
            </button>
        </div>
    );
}

export default MenuButton;
